import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateTag } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateTag() {
  return useMutation({
    mutationFn: async ({ item, tagId }) => {
      const payload = buildPayload(item);
      const response = await updateTag({ item: payload, tagId });
      return response;
    },
    onSuccess: () => {
      toast.success("Tag Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
